var map = {
	"./page-0.png": 1055,
	"./page-1.png": 1056,
	"./page-10.png": 1057,
	"./page-11.png": 1058,
	"./page-12.png": 1059,
	"./page-13.png": 1060,
	"./page-14.png": 1061,
	"./page-15.png": 1062,
	"./page-16.png": 1063,
	"./page-2.png": 1064,
	"./page-3.png": 1065,
	"./page-4.png": 1066,
	"./page-5.png": 1067,
	"./page-6.png": 1068,
	"./page-7.png": 1069,
	"./page-8.png": 1070,
	"./page-9.png": 1071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;